import { render, staticRenderFns } from "./customWidget.vue?vue&type=template&id=31e0c119"
import script from "./customWidget.vue?vue&type=script&lang=js"
export * from "./customWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports